import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import YearsOfExperience from './yearsOfExperience';
import Specialties from './specialties';
import PracticeLocation from './practiceLocation';
import DigitalVsNonDigitalAffinity from './digitalVsNonDigital';
import AffinityBySegment from './affinityBySegment';
import PersonalPromotionChannelAffinity from './personalPromotionChannelAffinity';
import Channels from './channels';
import DigitalChannelAffinity from './digitalChannelAffinity';
import VendorAffinity from './vendorAffinity';
import ContentAffinity from './contentAffinity';
import TopicAndTypes from './topicAndTypes';
import { TEPMETKO_COMPANY_ID, BAVENCIO_COMPANY_ID } from '../../../../constants';

function Demographics(props) {
    const { company } = useSelector((state) => state.company);
    const isHideSpecialtyGraph = (company?.id === TEPMETKO_COMPANY_ID || company?.id === BAVENCIO_COMPANY_ID );

    return (
        <>
            <Box className="padding-tb-24-rl-0">
                <Typography className="display-xs-medium gray-900">
                    Demographics
                </Typography>
            </Box>
            <Grid container spacing={'24px'}>
                {/* Years of Experience */}
                <Grid item xs={12} className="page-break" id="years-of-experience">
                    <YearsOfExperience />
                </Grid>
                {/* Specialties */}
                {
                    isHideSpecialtyGraph 
                        ?   null 
                        :   (<Grid item xs={12} className="page-break" id="specialties">
                                <Specialties />
                            </Grid>)
                }
                {/* Physician Practice Location */}
                <Grid item xs={12} className="page-break" id="practice-location">
                    <PracticeLocation />
                </Grid>
                {/* Digital Vs Non Digital Affinity */}
                <Grid item xs={12} className="page-break" id="digital-vs-non-digital-affinity">
                    <DigitalVsNonDigitalAffinity />
                </Grid>
                {/* Affinity by Segment*/}
                <Grid item xs={12} className="page-break" id="affinity-by-segment">
                    <AffinityBySegment />
                </Grid>
                {/* Personal Promotion Channel Affinity */}
                <Grid item xs={12} className="page-break" id="personal-promotion-channel">
                    <PersonalPromotionChannelAffinity />
                </Grid>
                {/* Channels */}
                <Grid item xs={12} className="page-break" id="channels">
                    <Channels />
                </Grid>
                {/* Digital Channel Affinity */}
                <Grid item xs={12} className="page-break" id="digital-channel-affinity">
                    <DigitalChannelAffinity />
                </Grid>
                {/* Vendor Affinity */}
                <Grid item xs={12} className="page-break" id="vendor-affinity">
                    <VendorAffinity />
                </Grid>
                {/* Content Affinity */}
                <Grid item xs={12} className="page-break" id="content-affinity">
                    <ContentAffinity />
                </Grid>
                {/* Topic and Types */}
                <Grid item xs={12} className="page-break" id="topic-types">
                    <TopicAndTypes />
                </Grid>
            </Grid>
        </>
    )
}

export default Demographics;